import React from "react";
import { Table, Modal, Button } from "react-bootstrap";
import { useState } from "react";

const UpdatesPage = () => {
  // State to control the modal visibility
  const [show, setShow] = useState(false);

  // Function to handle modal show/hide
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <div className="updates-page" style={{ padding: "20px" }}>
      <h2>Latest Updates</h2>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Date</th>
            <th>Title</th>
            <th>Description</th>
            <th>How to Video</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>18 Oct 2024</td>
            <td>Agents Feedback Tracking and Regeneration</td>
            <td>
              We have added the regeneration of agents based on their feedback. The feedback is also recorded in the database for future fine-tuning of the model.
            </td>
            <td>
              <Button variant="primary" onClick={handleShow}>
                Watch Video
              </Button>

              {/* Modal to show video */}
              <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                  <Modal.Title>Video: How to Add feedback</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <iframe
                    src="https://drive.google.com/file/d/1wqcSpMhDoQca-BEU9_pNHxMCBcmdZuDd/preview"
                   
                    width="100%"
                    height="480"
                    allow="autoplay"
                    title="Application Flow Video"
                  ></iframe>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default UpdatesPage;
